import React from 'react';
import { List, Datagrid, TextField, DateField, FunctionField, ReferenceField, useRedirect } from 'react-admin';
import { Card, CardContent, IconButton } from '@mui/material';
import { FilterBar, IndexField, ReportsActions } from '../../components';
import DownloadIcon from '@mui/icons-material/Download';

const ListReport = () => (
  <Card variant="elevation">
    <CardContent>
      <List actions={<ReportsActions title='Reports' />}>
        {/* Filter bar under the title */}
        <FilterBar />

        <Datagrid
          bulkActionButtons={false}
          size="medium"
          sx={{
            borderTop: '1px solid grey',
            maxHeight: '60vh',
            overflow: 'auto',
          }}
        >
          <FunctionField
            label="NO"
            render={(record) => <IndexField record={record} />}
          />
          <TextField
            label="SITE"
            source="schedule.route.site.name"
            sortable={false}
          />
          <TextField
            label="ROUTE"
            source="schedule.route.name"
            sortable={false}
          />
          <ReferenceField
            label="OPERATOR"
            reference="cognitoUsers"
            source="operator_id"
            sortable={false}
          >
            <TextField label="" source="name" />
          </ReferenceField>
          <DateField
            label="MODIFIED TIME"
            source="updatedAt"
            showTime
            sortable={false}
          />
          <FunctionField
            label="ACTION"
            render={(record) =>
              record.report_url && record.report_url !== '' ? (
                <IconButton
                  onClick={() => {
                    window.open(
                      record.report_url,
                      "Report",
                      `toolbar=0,menubar=0,width=${
                        (window.screen.availWidth / 3) * 2
                      },height=${(window.screen.availHeight / 3) * 2}`
                    );
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              ) : (
                <IconButton disabled>
                  <DownloadIcon />
                </IconButton>
              )
            }
          />
        </Datagrid>
      </List>
    </CardContent>
  </Card>
);

export default ListReport;
export { ListReport };